import { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useSelector } from "react-redux";
import { useSubmitQuestionFeedbackMutation } from '../../slices/fun_stuff/quizAdminSlice';
import Loader from '../Loader';

const QuizFeedback = ({ question_id, index }) => {
    const [explanations, setExplanations] = useState({});
    const [feedbackUsers, setFeedbackUsers] = useState({});
    const { quizUserInfo } = useSelector((state) => state.quizAuth);
    
    const [submitFeedback, { isLoading: feedbackLoading }] = useSubmitQuestionFeedbackMutation();

    const handleExplanationChange = (e, index) => {
        setExplanations({ ...explanations, [index]: e.target.value });
    };
    
    const handleFeedbackUserChange = (e, index) => {
        setFeedbackUsers({ ...feedbackUsers, [index]: e.target.value });
    };

    async function submitExplanation(e, index) {
        e.preventDefault();
        if (!explanations[index]) {
            window.alert("Please enter an explanation.");
            return;
        }

        let user = feedbackUsers[index] || quizUserInfo.username;
        if (!user) {
            window.alert("Please enter your name.");
            return;
        }
        try {
            await submitFeedback({
                question_id,
                user,
                report: explanations[index],
            }).unwrap();
            window.alert("Feedback submitted successfully!");
            hideFeedbackForm();
        } catch (error) {
            console.error(error?.data?.message || error.error);
        }
    }

    function showFeedbackForm(e) {
        e.preventDefault();
        const form = document.querySelector(`.error-form-${index}`);
        form.classList.remove('hidden');
    }

    function hideFeedbackForm() {
        const form = document.querySelector(`.error-form-${index}`);
        form.classList.add('hidden');
    }

    return (
        <>
        <Button id="show-feedback-btn" className="quiz-btn small" onClick={showFeedbackForm}>Something is wrong and I want to give you a piece of my mind</Button>
        <div className={`error-form-${index} hidden`}>
            <Form onSubmit={(e) => submitExplanation(e, index)}>
                <Form.Group controlId={`feedback-user-${index}`} className="my-2">
                    <Form.Label>Enter your name</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder={quizUserInfo ? quizUserInfo.username : "Enter your name"}
                        value={feedbackUsers[index]}
                        onChange={(e) => handleFeedbackUserChange(e, index)}
                    />
                </Form.Group>
                <Form.Group controlId={`explanation-${index}`} className="my-2">
                    <Form.Label>Explanation</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={3}
                        placeholder="Enter explanation"
                        value={explanations[index] || ''}
                        onChange={(e) => handleExplanationChange(e, index)}
                    />
                </Form.Group>
                <Button variant="dark" type="submit">Submit Feedback</Button>
            </Form>
        </div>
        {feedbackLoading && <Loader />}
        </>
    );
}

export default QuizFeedback;